export default ".criteria-list{margin:0;padding-left:0;list-style-type:none}.icon-pass{color:#3f946d}.icon-fail{color:#c04b4f}.icon-pending{color:#378398}";